import EmailSettings from './emailSettings.container';

export default EmailSettings;
